<div class="question">
  <p [class]="{'required' : question.isRequired}">{{question.title}}</p>
  <app-attachments
    [downloadOnly]="true" 
    [attachments]="question.attachments"
    [downloadRoute]="downloadRoute">
  </app-attachments>
  <div>
    <div *ngFor="let choice of question.choices">
      <input type="radio" id="choice{{choice.id}}" name="question{{question.id}}" class="form-check-input" [value]="choice.value"
             [ngModel]="question.answers[0].value" (change)="onChoiceChange(choice)" mdbInput data-success=" " />
      <label class="form-check-label" for="choice{{choice.id}}">{{choice.text}}</label>
    </div>
  </div>
</div>
